import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Space,
  Switch,
  Card,
  Row,
  Col,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import { systemActions } from "../../store";
import { useDispatch } from "react-redux";

import InputColor from "react-input-color";
import { LocalImage } from "../../components/ImageUtil";
import UploadFileProp from "../../components/UploadFileProp";
import modulesApi from "../../api/module/modulesApi";

const BannerTop = (props) => {
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const [colorBg, setColorBg] = useState({
    h: 88,
    s: 65,
    v: 71,
    r: 127,
    g: 182,
    b: 64,
    a: 100,
    hex: "#7fb640",
    rgba: "rgba(127,182,64,1)",
  });

  const [isModalEditContractVisible, setIsModalEditContractVisible] =
    useState(false);

  const setLoading = (status) => {
    dispatch(systemActions.setLoadingSystem(status));
  };

  const [dataBanner, setDataBanner] = useState(null);
  const [valueFormData, setValueFormData] = useState({});
  const [bannerPc, setBannerPc] = useState(null);
  const [bannerMb, setBannerMb] = useState(null);

  useEffect(() => {
    getBannerTop();
  }, []);

  const getBannerTop = () => {
    setLoading(true);
    modulesApi
      .getBannerTop()
      .then((res) => {
        if (res?.values !== null) {
          setDataBanner(res);
          setBannerPc(res.values?.bannerPc);
          setBannerMb(res.values?.bannerMb);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const showEditModal = () => {
    if (dataBanner) {
      setColorBg(dataBanner.values?.background);
      setValueFormData({
        link: dataBanner.values?.link,
        display: dataBanner.values?.display ?? false,
      });
    }

    setIsModalEditContractVisible(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    const check = bannerPc === null || bannerMb === null;
    if (!check) {
      createBanner(values);
    } else {
      Swal.fire({
        title: "Thất bại!",
        text: "Vui lòng tải ảnh lên!",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  const createBanner = (data) => {
    setLoading(true);
    const payload = {
      "top-banner": {
        link: data.link,
        display: data.display,
        background: colorBg,
        bannerPc: bannerPc,
        bannerMb: bannerMb,
      },
    };
    modulesApi
      .createModules(payload)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa banner thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          getBannerTop();
          setIsModalEditContractVisible(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setBannerPc(null);
        setBannerMb(null);
      });
  };

  const closePopup = useCallback(() => {
    setValueFormData({});
    form.resetFields();
    setIsModalEditContractVisible(false);
  }, [form]);

  const onUploadPc = (url) => {
    setBannerPc(url);
  };

  const onUploadMb = (url) => {
    setBannerMb(url);
  };
  return (
    <>
      <div className="tabled">
        <Space size={10}>
          <Button type="dashed" onClick={() => showEditModal()} size="small">
            <EditOutlined /> &nbsp; Sửa banner
          </Button>
        </Space>
        <br />
        <br />

        <div className="tabled">
          <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
            <Row align="center" className="mb-24 mt-24" gutter={[24, 0]}>
              <Col span={2}>
                <label>Banner PC</label>
              </Col>
              <Col span={8}>
                <LocalImage src={bannerPc} />
              </Col>
            </Row>

            <Row align="center" className="mb-24 mt-24" gutter={[24, 0]}>
              <Col span={2}>
                <label>Banner Mobile</label>
              </Col>
              <Col span={8}>
                <LocalImage src={bannerMb} />
              </Col>
            </Row>
          </Card>
        </div>

        <Modal
          title="Sửa banner"
          visible={isModalEditContractVisible}
          size="large"
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
        >
          <div>
            <Form
              initialValues={valueFormData}
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="Trạng thái"
                valuePropName="checked"
                name="display"
              >
                <Switch />
              </Form.Item>

              <Form.Item label="Màu nền">
                <InputColor initialValue={colorBg.hex} onChange={setColorBg} />
              </Form.Item>

              <Form.Item
                label="Liên kết"
                name="link"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập liên kết!",
                  },
                ]}
              >
                <Input placeholder="Nhập liên kết..." />
              </Form.Item>
              <Row>
                <Col>
                  <Form.Item label="Banner PC">
                    <UploadFileProp
                      onUploadPc={onUploadPc}
                      image={bannerPc}
                      type="first"
                    />
                  </Form.Item>
                </Col>

                <Col offset={2}>
                  <Form.Item label="Banner Mobile">
                    <UploadFileProp
                      onUploadMb={onUploadMb}
                      image={bannerMb}
                      type="second"
                    />
                  </Form.Item>
                  -
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default BannerTop;
